import { useAutoneTranslation } from '@autone/translations';
import { Separator, ToggleGroup, ToggleGroupItem } from '@autone/ui';
import { AutoneIcon } from '@autone/ui-next/icons';
import { useCallback } from 'react';

import { type APP_NAME } from '../../../consts';
import {
  type TableNamesWithManagedByAutoneToggle,
  useAssortmentSessionStorageAtom,
} from '../../../storage/session-storage';

interface ManagedByAutoneToggleProps {
  tableName: TableNamesWithManagedByAutoneToggle;
}

export const ManagedByAutoneToggle = ({
  tableName,
}: ManagedByAutoneToggleProps) => {
  const { t } = useAutoneTranslation<typeof APP_NAME>();
  const [managedByAutone, setManagedByAutone] = useAssortmentSessionStorageAtom(
    `${tableName}.extrasMenu.managedByAutoneToggle`,
  );

  type ToggleValues = typeof managedByAutone;

  const handleToggleFilter = useCallback(
    (value: ToggleValues | '') => {
      setManagedByAutone(value === '' ? 'off' : value);
    },
    [setManagedByAutone],
  );

  return (
    <div className="flex flex-row gap-2 items-center px-2 py-1 self-stretch justify-between">
      <label>{t('quick-filters.managed-by.label')}</label>
      <ToggleGroup
        variant={'primary'}
        type={'single'}
        value={managedByAutone}
        onValueChange={handleToggleFilter}
      >
        <ToggleGroupItem value={'autone' satisfies ToggleValues}>
          <AutoneIcon className="!size-3" />
          {t('quick-filters.managed-by.autone')}
        </ToggleGroupItem>
        <Separator orientation="vertical" />
        <ToggleGroupItem value={'you' satisfies ToggleValues}>
          {t('quick-filters.managed-by.you')}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};
